import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { ClientConfirmPhoneNumberDocument } from "../../__generated__/graphql";

export function useClientConfirmPhoneNumber() {
  const [mutate, state] = useMutation(ClientConfirmPhoneNumberDocument);

  const confirmPhoneNumber = useCallback(
    async (phone: string, code: string, onSignUp?: boolean) => {
      const { data } = await mutate({ variables: { input: { phone, code, onSignUp } } });
      return Boolean(data?.clientConfirmPhoneNumber?.result);
    },
    [mutate],
  );

  return [confirmPhoneNumber, state] as const;
}
